import styled from "styled-components";
import {
  Button,
  Divider,
  Type,
} from "discover.medical.react-component-library";

export const DrugInteractionDetailsContainer = styled.div`
  max-width: 70.5rem;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.space.xxxl};
`;

export const DrugInteractionDetailsBackLink = styled(Button)`
  padding: ${({ theme }) => theme.space.md} 0;
  font-size: ${({ theme }) => theme.font.size.sm};
  max-height: 4rem;
`;

export const DrugInteractionDetailsDivider = styled(Divider)`
  margin-bottom: ${({ theme }) => theme.space.lg};
`;
export const DrugInteractionDetailsHeader = styled(Type)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 0;
  }
`;
